import { render, staticRenderFns } from "./CmlPopupCard.vue?vue&type=template&id=027f113c"
import script from "./CmlPopupCard.vue?vue&type=script&lang=js"
export * from "./CmlPopupCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports